import React from 'react';
import { ArrowDown } from 'lucide-react';
import { SectionHeading } from './SectionHeading';

/**
 * BLOCK: process_steps
 * ACF layout name: `block_process_steps`
 *
 * Fields:
 *  - eyebrow  (text)
 *  - heading  (text)
 *  - intro    (textarea, optional)
 *  - steps    (repeater: step_number, step_title, step_description)
 *
 * Consolidates the "What to expect" numbered flows on all three service pages.
 * Step numbers are derived from index so editors never hand-type "01", "02"…
 */

export interface ProcessStep {
  title: string;
  description: string;
}
interface ProcessStepsProps {
  eyebrow?: string;
  heading: string;
  headingId?: string;
  intro?: string;
  steps: readonly ProcessStep[];
}
export function ProcessSteps({
  eyebrow,
  heading,
  headingId,
  intro,
  steps
}: ProcessStepsProps) {
  return <section aria-labelledby={headingId} data-id="element-144" data-mp="c98tsk1bk8pd">
      <SectionHeading eyebrow={eyebrow} heading={heading} id={headingId} intro={intro} data-id="element-145" data-mp="ccd47z5do0oh" />
      <ol className="mt-10 border-y border-cream-200" data-id="element-146" data-mp="9a19tl5z3xf9">
        {steps.map((step, index) => <li key={step.title} className="grid gap-4 border-b border-cream-200 py-7 last:border-b-0 sm:grid-cols-[54px_1fr]" data-id="element-147" data-mp="4bzqcz4mxw39" data-mpi={index}>
            <p className="font-serif text-2xl italic text-sage-700" aria-hidden="true" data-id="element-148" data-mp="i94torcysgut">
              {String(index + 1).padStart(2, '0')}
            </p>
            <div data-id="element-149" data-mp="s7ash03h56vg">
              <h3 className="font-serif text-2xl text-charcoal" data-id="element-150" data-mp="nac0oo7a9c0f">
                {step.title}
              </h3>
              <p className="mt-2 text-base font-light leading-relaxed text-charcoal-50" data-id="element-151" data-mp="111h3fz5y6kez">
                {step.description}
              </p>
              {index < steps.length - 1 && <ArrowDown size={18} strokeWidth={1.25} className="mt-5 text-sage-700" aria-hidden="true" data-id="element-152" data-mp="1azwllcmzyjcc" />}
            </div>
          </li>)}
      </ol>
    </section>;
}